import { getActiveSocialPlatforms } from '@modules/_shared/components/visibility-drawer/edit-modals/editModalConfig';
import EditableSectionHeader from '@modules/_shared/components/visibility-drawer/sections/EditableSectionHeader';
import { SocialIconList } from '@modules/_shared/components/visibility-drawer/sections/SocialMediaIcon';
import {
  type SectionProps,
  isAgencyEntity,
} from '@modules/_shared/components/visibility-drawer/types';
import { useDrawerContext } from '@modules/_shared/components/visibility-drawer/VisibilityDrawer';
import { useLocale } from '@shared/hooks/locale';

const SocialMediaSection = ({ entity, onEdit }: SectionProps) => {
  const { t } = useLocale();
  const { setOpenModal } = useDrawerContext();
  const socialIcons = getActiveSocialPlatforms(
    entity as Record<string, unknown>,
    isAgencyEntity(entity),
  );

  return (
    <EditableSectionHeader
      title={t('Social media')}
      onEdit={onEdit ?? (() => setOpenModal('socialMedia'))}
    >
      <SocialIconList socialIcons={socialIcons} />
    </EditableSectionHeader>
  );
};

export default SocialMediaSection;
